import apiUrl from '../../../constants';
import axios from 'axios';
import { ModelSelect } from 'vue-search-select';
import DatePicker from 'vue2-datepicker';
import BagCloseDetails from './BagCloseDetails/index.vue';
import ApiResponseLog from './ApiResponseLog/index.vue';
import BagInShipmentLiveResponse from './BagInShipmentLiveResponse/index.vue';
import pushShipmentDataNew from './pushShipmentDataNew/index.vue';
import hubInscanLogs from './hubInscanLogs/index.vue';

export default {
	name: 'sorter',
	components: {
		DatePicker,
		ModelSelect,
		'first': BagCloseDetails,
		'second': ApiResponseLog,
		'third': hubInscanLogs,
		'fourth': BagInShipmentLiveResponse,
		'Fifth': pushShipmentDataNew
	},
	props: [],
	data() {
		return {
			hubLoading: '',
			hubid: "",
			hubdetailsarray: [],
			HubNameData: [],
			DestHubNameData: [],
			KENGIC_API_KEY: '',
			isEnable: false,
			currentTab: 'First',
			componentKey: 0,
			tabs: [{
				key: 'First',
				value: 'Bag Close Details'
			},
			{
				key: 'Second',
				value: 'Api Response Log'
			},
			{
				key: 'Third',
				value: 'Hub Inscan Logs'
			},
			{
				key: 'Fourth',
				value: 'BagIn Shipment Live Response'
			},
			{
				key: 'Fifth',
				value: 'Push Shipment Data New System'
			}
			],
		}
	},
	computed: {
		currentTabComponent: function () {
			this.componentKey += 1
			return this.currentTab.toLowerCase()
		}
	},
	mounted() {
		this.getHubName();
		if (process.env.NODE_ENV == 'staging' || process.env.NODE_ENV == 'testing') {
			this.KENGIC_API_KEY = '36BCB392F5C18C';
		}
		else if (process.env.NODE_ENV == 'production' || process.env.NODE_ENV == 'preproduction')
			this.KENGIC_API_KEY = '850BF5DB3BF136';
	},
	methods: {
		getHubName() {
			this.hubLoading = 'Loading Hub...'
			var i = 0;
			axios({
				method: 'GET',
				'url': apiUrl.api_url_hubops + 'getSorterHubDetails?vendorName=KENGIC',
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
				.then(result => {
					this.hubLoading = ''
					var HubNameData = result.data.ResponseData
					this.hubdetailsarray = result.data.ResponseData
					for (i = 0; i < HubNameData.length; i++) {
						this.DestHubNameData.push({
							value: HubNameData[i].sorterhubid,
							text: HubNameData[i].sorterhubname + ' (' + HubNameData[i].sorterhubid + ')'
						})
						this.HubNameData = this.DestHubNameData
					}
				}, error => {
					console.error(error)
				})
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/KengicSorter/KengicSorter.js